import { useState } from 'react';

export interface FaqItem {
  question: string;
  answer: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="bg-white rounded-2xl border border-background-200/70 px-4 md:px-6 divide-y divide-background-200/50">
      {items.map((item, index) => (
        <div key={index} className="border-b border-background-200/50 last:border-0">
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
            aria-expanded={openIndex === index}
          >
            <h4 className="text-foreground-900 text-sm font-bold leading-snug group-hover:text-primary-600 transition-colors">
              {item.question}
            </h4>
            <div
              className={`w-7 h-7 flex items-center justify-center rounded-full border-2 flex-shrink-0 transition-all duration-300 ${
                openIndex === index
                  ? 'border-primary-500 bg-primary-500 text-white rotate-45'
                  : 'border-background-300 text-foreground-400'
              }`}
            >
              <i className="ri-add-line text-sm" />
            </div>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
            }`}
          >
            <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}